export const INTERNAL_EVENT_SECURITY_KEY = 'pimster-embed';
export const INTERNAL_EVENT_ERROR_KEY = '[Internal Event Error]';
